export default ({ pageLimit, searchExpression, cursorState }) => {
  const searchParams = new URLSearchParams();

  if (pageLimit) {
    searchParams.set('limit', pageLimit);
  }

  if (cursorState) {
    searchParams.set('cursorState', cursorState);
  }

  if (searchExpression) {
    searchParams.set('filter[searchText]', searchExpression);
  }

  const searchParamsString = searchParams.toString();

  return searchParamsString ? `?${searchParamsString}` : '';
};
